import axios from 'axios'

export function getPutterModels() {
  return axios
    .get(process.env.PUBLIC_URL + '/api/legacy/allproducts')
    .then((response) => response.data)
    ;
}

export function getOptions(id) {
  return axios
    .get(process.env.PUBLIC_URL + `/api/legacy/product/${id}`)
    .then((response) => response.data)
    ;
}

export function getCustomInstance(id) {
  return axios
    // .get(`/custom-shop/handlers/options.ashx?type=putter_template&modelId=${id}`)
    .get(process.env.PUBLIC_URL + `/api/legacy/instance/${id}`)
    .then((response) => response.data)
    ;
}
export function getOrderInstance(lineItemId) {
  return axios
    .get(process.env.PUBLIC_URL + `/api/legacy/orderinstance/${lineItemId}`)
    .then((response) => response.data)
    ;
}

export function addToCart(APIInstance){
	return axios
	.get('/store/user/getcookiemappingid/')
	.then((response) => axios
    .post(process.env.PUBLIC_URL + '/api/legacy/submit', APIInstance)
    .then((response) => response.data))
    ; 
}

export function addToSaved(APIInstance){
  return axios
    .post(process.env.PUBLIC_URL + '/api/legacy/addtosaved', APIInstance)
    .then((response) => response.data)
    ; 
}

export function checkInitialsValid(initials, vm, callback){
  return axios
    .post(process.env.PUBLIC_URL + '/api/legacy/ValidateText', initials, 
        {
            headers: { 
                'Content-Type' : 'application/json' 
            }
        })
    .then(function(response) { 
	let test1 = response.data;
	let test2 = test1;
	callback(vm, response.data);
	})
    ; 
}